import css from 'classnames'
import { useTranslation } from 'react-i18next'
import { BlocketSVG } from '~/shared/ui/SVG/blockedSVG'
import { SVGEye } from '~/shared/ui/SVG/SVGEye'

type CategoryStatusIndicatorsProps = {
  enabled?: boolean
  showInMenu: boolean
  className?: string
}

export const CategoryStatusIndicators = ({
  enabled,
  showInMenu,
  className,
}: CategoryStatusIndicatorsProps) => {
  const { t } = useTranslation()
  const isDisabled = enabled === false
  const isHidden = !showInMenu

  if (!isDisabled && !isHidden) {
    return null
  }

  return (
    <div
      className={css(
        'flex shrink-0 items-center gap-3 whitespace-nowrap text-gray-400',
        className,
      )}
    >
      {isDisabled ? (
        <div className="flex items-center gap-1.5">
          <BlocketSVG size="18" color="#9CA3AF" />
          <p>{t('categoryStatusOff')}</p>
        </div>
      ) : null}

      {isHidden ? (
        <div className="flex items-center gap-1.5">
          <SVGEye icon="visibilityOff" size="18" color="#9CA3AF" />
          <p>{t('categoryStatusHidden')}</p>
        </div>
      ) : null}
    </div>
  )
}
